import React, { FC, useState, useEffect, Fragment } from 'react';
import { EditSurgeProps } from '../general/types';
import SurgeTabs from '../surge-tabs';
import ScheduledSurgeCard from '../schedule-card';
import { ScheduledSurgeTabType } from '../surge-tabs/types';
import EditSingleSurgeItem from '../surge-tabs/surge-schedule/edit-single-surge';
import { Paginate } from '@cokitchen/cokitchen-components';
import { ScheduleSurgeType } from 'models/surge.model';
import { apiService } from 'utils/api';

const EditPolygonSurge: FC<EditSurgeProps> = ({ confirm, setLoading, onClose, setStep, step }) => {
  const [activeTab, setActiveTab] = useState<ScheduledSurgeTabType>('Scheduled Surge');
  const [surgeLoading, setSurgeLoading] = useState(false);
  const [surgeList, setSurgeList] = useState<ScheduleSurgeType[]>([]);
  const [pageCount, setPageCount] = useState<number>(1);
  const [surgeItem, setSurgeItem] = useState({} as ScheduleSurgeType);
  const tabList: ScheduledSurgeTabType[] = ['Scheduled Surge', 'Recurrent Surge'];
  const getSurgeList = async (pageNo = 1) => {
    setLoading(true);
    const data = {
      recurrent: activeTab === 'Recurrent Surge'
    };
    const url = `logistics/surge/general/schedule/get/${pageNo}`;
    const res = await apiService.post(url, {
      data,
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
    });
    const results = res?.data?.data;
    setSurgeList(results);
    setSurgeLoading(false);
    setPageCount(Math.ceil(+res?.data?.total / 10));
    setLoading(false);
  };

  useEffect(() => {
    getSurgeList();
  }, [activeTab]);

  const getSelectedPageData = async (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    await getSurgeList(pageNo);
  };

  const handleClick = (item: ScheduleSurgeType) => {
    setStep(step + 1);
    setSurgeItem(item);
  };

  return (
    <div className='w-full'>
      {step === 2 && (
        <>
          <SurgeTabs active={activeTab} setActive={setActiveTab} list={tabList} />
          <div className='h-[350px] overflow-y-auto'>
            {surgeLoading ? (
              <div className='place-content-center place-items-center flex h-full'>Loading...</div>
            ) : surgeList.length ? (
              <div className='h-[300px] overflow-y-auto'>
                {surgeList.map((item, index) => (
                  <ScheduledSurgeCard
                    onClick={() => handleClick(item)}
                    type={activeTab}
                    surge={item}
                    key={index}
                    isLastItem={index + 1 === surgeList.length}
                  />
                ))}
              </div>
            ) : (
              <div className='place-content-center place-items-center flex h-full'>
                There are no scheduled surges
              </div>
            )}
          </div>
          <Paginate pageCount={pageCount} onPageChange={getSelectedPageData} />
        </>
      )}
      {step === 3 && (
        <EditSingleSurgeItem
          confirm={confirm}
          onClose={onClose}
          setLoading={setLoading}
          surgeItem={surgeItem}
        />
      )}
    </div>
  );
};

export default EditPolygonSurge;
